import React from 'react';
import PropTypes from 'prop-types';

import Definition from '../../../shared/Definition';

const SireComment = ({ sireComment }) => (
    !!sireComment && (
        <Definition
            term="Sire&nbsp;comment"
            description={sireComment}
        />
    )
);

SireComment.propTypes = {
    sireComment: PropTypes.string,
};

export default SireComment;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/SireComment.jsx